import { CogPlayIcon } from './CogPlayIcon';

/**
 * author: Michael Irigoyen
 * id FF5D0943-FA1E-423E-B6A7-0210449D2C29
 * name cog-play
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cog-play.svg
 * tags
 * - Settings 
 */
export const GearPlayIcon = CogPlayIcon;
export default GearPlayIcon